import { Skeleton, styled, Theme, Typography } from "@mui/material";
import { forwardRef, ReactNode } from "react";

import { PAGE_HEIGHT } from "constants/styles";

import type { SystemStyleObject } from "@mui/system";

export interface PageWrapperProps {
  banner?: ReactNode;
  children: ReactNode;
  title?: string;
  wrapperSx?: SystemStyleObject<Theme>;
  isFetching?: boolean;
}

export const PageWrapper = forwardRef<HTMLDivElement, PageWrapperProps>(
  ({ banner, children, title, wrapperSx, isFetching }, ref) => {
    return (
      <Wrapper sx={wrapperSx} ref={ref}>
        {banner}
        <ContentWrapper>
          {isFetching && (
            <Skeleton variant="text" width={200} sx={{ mt: 4, mb: 4 }} />
          )}
          {title && !isFetching && (
            <Typography
              data-testid="page-header-title"
              variant="h4"
              sx={{ mt: 4, mb: 4 }}
            >
              {title}
            </Typography>
          )}
          {children}
        </ContentWrapper>
      </Wrapper>
    );
  }
);

const ContentWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.ui10,
  paddingTop: 0,
}));

const Wrapper = styled("main")(({ theme }) => ({
  backgroundColor: theme.palette.ui10,
  height: PAGE_HEIGHT,
  position: "relative",
  overflowX: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));
